import { useQuery } from "@tanstack/react-query";
import { clientApi } from "../../services/endpoints";
import { unwrapList } from "../../services/response";
import type { QueryParams } from "../../types/api";
import type { Amt } from "../../types/entities";

export const clientsQueryKey = ["clients"];

/**
 * Query options for clients (Ämter), keyed by the fetch params so each scope
 * (all / by-seminar / search) is cached independently. Invalidate
 * clientsQueryKey after a client create/update to drop every cached scope.
 */
export const clientsQueryOptions = (params: QueryParams = {}) => ({
  queryKey: [...clientsQueryKey, params],
  queryFn: async (): Promise<Amt[]> => {
    const res = await clientApi.getAll(params);
    return unwrapList<Amt>(res);
  },
});

/**
 * Live clients query. Replaces the old getStoredClientData + shared
 * AppState.storedClientSelection mirror: each consumer reads the scope it needs
 * (all / {seminar_id} / search filters) straight from the cache, so same-scope
 * consumers (invoice + seminar detail for one seminar) dedupe on one key.
 * Refreshed by invalidating ['clients'] after a client create/update.
 */
export const useClients = (params: QueryParams = {}, enabled = true) =>
  useQuery({ ...clientsQueryOptions(params), enabled });
